import { render, staticRenderFns } from "./PublicAffairsAppTabbed.vue?vue&type=template&id=c51722e4&"
import script from "./PublicAffairsAppTabbed.vue?vue&type=script&lang=js&"
export * from "./PublicAffairsAppTabbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports